import { render, staticRenderFns } from "./CardTable.vue?vue&type=template&id=5393a98a&"
import script from "./CardTable.vue?vue&type=script&lang=ts&"
export * from "./CardTable.vue?vue&type=script&lang=ts&"
import style0 from "./CardTable.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports